function helperGetDateMonth (date) {
  return date.getMonth()
}

module.exports = helperGetDateMonth



//////////////////
// WEBPACK FOOTER
// ./~/_xe-utils@2.8.3@xe-utils/methods/date/helperGetDateMonth.js
// module id = 182
// module chunks = 106